<template>
<div class="c-table-item">
  <div class="c-table-column">
    {{user.name}}
  </div>
  <div class="c-table-column">
    {{user.surname}}
  </div>
  <div class="c-table-column">
    {{user.email}}
  </div>
  <div class="action-field">
  <b-dropdown right no-caret>
    <template #button-content>
      <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z" fill="#A9A9A9"/>
        </svg>
    </template>
    <b-dropdown-item @click="editMember(user.email)">{{resource["userAction.Edit"]}}</b-dropdown-item>
    <b-dropdown-item @click="removeMember(user.id)">{{resource["userAction.Remove"]}}</b-dropdown-item>
  </b-dropdown>
</div>
</div>
</template>

<style lang="scss" scoped>

.c-table-item{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding:12px 16px;
  background: #F5F5F5;
  border-bottom: 1px solid #E4E4E4;
  position:relative;
  .c-table-column{
    width: 25%;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #1D1D1D;
  }
  &:nth-child(2n){
    background: #FFFFFF;
  }
  >:nth-last-child(2){
    width: calc(50% - 36px);

  }
}
.action-field{
  display: flex;
  align-items: center;
  justify-items: center;
  cursor: pointer;
  background: transparent;
  ::v-deep .b-dropdown {
    &.show{
      path{
        fill: #FF8D06;
      }
    }
  }
  ::v-deep .dropdown-menu {
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    min-width:auto !important;
    >:last-child .dropdown-item {
      border-bottom: none !important;
    }
  }
  ::v-deep .btn {
    background: transparent;
    height: 24px;
  }
  ::v-deep .dropdown-item {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 16px !important;
    color: #353535 !important;
    border-bottom: 1px solid #E4E4E4 !important;
    padding: 8px !important;
    text-align: center !important;
}
}
</style>

<script>
export default {
  name: 'UserListItem',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  mounted() {
  },
  methods: {
    editMember(email) {
      this.$emit('editMemberHandler', email);
    },
    removeMember(email) {
      this.$emit('removeMemberHandler', email);
    },
  },
};
</script>
